import React, {useState, useContext} from 'react'
import {useStripe, useElements} from '@stripe/react-stripe-js';
import { Button, Modal, Divider } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import { Text, Translate, LanguageContext } from '../../helpers/language';

const SubscriptionChangeConfirmationDialog = (props) => {
    const languageContext = useContext(LanguageContext);
    const stripe = useStripe();
    const elements = useElements();

    const [errorMessage, setErrorMessage] = useState('');
    const [error, setError] = useState(false);
    const [hasCard, setHasCard] = useState(false);
    const [loading, setLoading] = useState(false);
    const [cardHolderName, setCardHolderName] = useState('');

    const {  
            is_open,
            lawyer_id,
            user_name,
            current_subscription,
            current_subscription_item,
            payment_method,
            button_disabled,
            closeModal,
            createSubscription,  
            updateSubscription,  
            confirmSubscriptionUpdate,
        } = props;


    const checkSubscription = (subscription) => {
        if (subscription.status === 'active' || subscription.status === 'trialing' ) {
            NotificationManager.success(Translate(languageContext, 'subscription_plan_udated'))
            confirmSubscriptionUpdate();
            closeModal();
            return;
        } 
        // If it's a first payment attempt, the payment intent is on the subscription latest invoice.    
        const paymentIntent = subscription.latest_invoice.payment_intent;
        if ( paymentIntent.status === 'requires_action') {
            stripe.confirmCardPayment(paymentIntent.client_secret, {
                payment_method: paymentIntent.payment_method }).then ( paymentResult => {
                if (paymentResult.error) {              
                    NotificationManager.error(Translate(languageContext, 'subscription_plan_udate_fail'));
                    setLoading(false);
                    closeModal();
                } else {
                    if (paymentResult.paymentIntent.status === 'succeeded') {
                        NotificationManager.success(Translate(languageContext, 'subscription_plan_udated'))
                        confirmSubscriptionUpdate();                       
                        closeModal();
                    } else {                
                        NotificationManager.error(Translate(languageContext, 'subscription_plan_udate_fail'))
                        closeModal();
                    }
                }
                }, e =>  {
                    console.error(e);            
                    NotificationManager.error(Translate(languageContext, 'subscription_plan_udate_fail'));
                    setLoading(false);
                    closeModal();
                });                      
            
        } else {      
            NotificationManager.error(Translate(languageContext, 'subscription_plan_udate_fail'));
            setLoading(false);
            closeModal();
        }
    }
    

    const postSubscription = (lawyerId, paymentMethod) => {        
        createSubscription(lawyerId, paymentMethod).then( subscription => {
        if (subscription) {        
            checkSubscription(subscription);
        } else {        
            NotificationManager.error(Translate(languageContext, 'subscription_plan_udate_fail'))
            setLoading(false);
            closeModal();
        }
        },
        e => {      
            console.error(e);
            NotificationManager.error(Translate(languageContext, 'subscription_plan_udate_fail'))
            setLoading(false);
            closeModal();
        });
    }

    const putSubscription = (lawyerId, paymentMethod, subscriptionId, subscriptionItemId) => {
        updateSubscription(lawyerId, paymentMethod, subscriptionId, subscriptionItemId).then( subscription => {
        if (subscription) {        
            checkSubscription(subscription);
        } else {        
            NotificationManager.error(Translate(languageContext, 'subscription_plan_udate_fail'))
            setLoading(false);
            closeModal();
        }
        },
        e => {      
            NotificationManager.error(Translate(languageContext, 'subscription_plan_udate_fail'))
            setLoading(false);
            closeModal();
        });
    }

    const changeSubscription = async (evt) => {
        setLoading(true);
        evt.preventDefault();
        try {            
            if (!stripe || !elements || !lawyer_id) {       
                NotificationManager.error(Translate(languageContext, 'subscription_payment_method_update_fail')); 
            } 
            if (current_subscription && current_subscription.id && current_subscription_item && current_subscription_item.id) {
                putSubscription(lawyer_id, payment_method, current_subscription.id, current_subscription_item.id)
            } else {
                postSubscription(lawyer_id, payment_method);
            }       

        } catch(exc) {
            console.error(exc);
            NotificationManager.error(Translate(languageContext, 'subscription_plan_udate_fail'))
            setLoading(false);
            closeModal();
        }
        
    };  

    return (
        <Modal
            open={is_open}
            onClose={closeModal}
            className='lisia-modal lisia-dialog'
        >
            <Modal.Content>
                <h3 className='text-center'>{user_name}, <Text tid='subscription_update_plan_confirm' /></h3>
                <Divider />
                <p className='text-center'><b><Text tid='subscription_plan_change_description' /></b></p>
            <Button disabled={button_disabled || loading } className='lisia-blue' onClick={changeSubscription} style={{width: '100%'}}><Text tid='subscription_change_plan' /></Button>
            </Modal.Content>
            <Modal.Actions>
            <div className='footer'>
                <Link onClick={closeModal} to='#'>
                        <Text tid="back" />
                </Link>  
            </div>
            </Modal.Actions>
        </Modal>       
    );

}

export default SubscriptionChangeConfirmationDialog